import { format } from 'date-fns';
import { ar, enUS, fr } from 'date-fns/locale';
import {
  CheckCircle, AlertTriangle, LogOut, XCircle, LogIn, CalendarDays,
} from 'lucide-react';

export const todayStr = format(new Date(), 'yyyy-MM-dd');
export const toStr = (d) => format(d, 'yyyy-MM-dd');

export const getDateFnsLocale = (language) => {
  if (language?.startsWith('ar')) return ar;
  if (language?.startsWith('en')) return enUS;
  return fr;
};

export const flattenDepartments = (nodes = [], acc = []) => {
  nodes.forEach((node) => {
    acc.push({ id: node.id, name: node.name });
    if (node.enfants?.length) flattenDepartments(node.enfants, acc);
  });
  return acc;
};

export const fmtHours = (h) => {
  if (h == null) return '—';
  const hours = Math.floor(h);
  const mins  = Math.round((h - hours) * 60);
  return `${hours}h${mins > 0 ? String(mins).padStart(2, '0') : ''}`;
};

export const fmtMinutes = (m) => {
  if (!m) return null;
  const h = Math.floor(m / 60);
  const mn = m % 60;
  return h > 0 ? `${h}h${String(mn).padStart(2, '0')}` : `${mn} min`;
};

export const STATUS_CONFIG = {
  present:               { labelKey: 'attComp.statusBadge.present',              color: 'bg-green-950/30 text-green-400',   icon: CheckCircle },
  late:                  { labelKey: 'attComp.statusBadge.late',                 color: 'bg-red-950/30 text-red-400',       icon: AlertTriangle },
  early_departure:       { labelKey: 'attComp.statusBadge.earlyDep',             color: 'bg-orange-950/30 text-orange-400', icon: LogOut },
  late_early_departure:  { labelKey: 'attComp.statusBadge.lateEarlyDep',         color: 'bg-red-950/30 text-red-400',       icon: AlertTriangle },
  absent:                { labelKey: 'attComp.statusBadge.absent',               color: 'bg-red-950/30 text-red-400',       icon: XCircle },
  absence_justifiee:     { labelKey: 'attComp.statusBadge.justifiedAbsence',     color: 'bg-primary/10 text-primary',       icon: CheckCircle },
  missing_exit:          { labelKey: 'attComp.statusBadge.missingExit',          color: 'bg-yellow-950/30 text-yellow-400', icon: LogIn },
  no_schedule:           { labelKey: 'attComp.statusBadge.noSchedule',           color: 'bg-muted text-muted-foreground',   icon: CalendarDays },
  day_off:               { labelKey: 'attComp.statusBadge.dayOff',               color: 'bg-muted text-muted-foreground',   icon: null },
  public_holiday:        { labelKey: 'attComp.statusBadge.publicHoliday',        color: 'bg-purple-950/30 text-purple-400', icon: CalendarDays },
};
